import React from 'react';
import { Box, Typography } from '@mui/material';
import CommonImages from '../../../commons/images';
import * as styles from './styles';

function BrandSpace() {
    return (
        <Box sx={styles.brandCol}>
            <Box
                component="img"
                src={CommonImages.ECAL_SYMBOL}
                alt="ECAL"
                sx={styles.brandLogo}
            />
            <Typography sx={styles.brandTagline}>
                ECAL is the world's leading calendar marketing platform. We are the OFFICIAL and EXCLUSIVE digital calendar provider for hundreds of the world's very best brands, providing an entirely FREE service for end-users to connect to the brands and events they love most.
            </Typography>
        </Box>
    );
}

export default BrandSpace;
